import React, { useEffect, useState, useRef, forwardRef, useMemo, useCallback } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ButtonBase from "@mui/material/ButtonBase";

import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  updateCartItems,
  updateRestaurantDetail,
  updateSelectedMenuData,
} from "../redux/actions/restaurantDataActions";

import MenuTypeFilter from "../components/MenuTypeFilter";
import MenuCategoryGroupFilter from "../components/MenuCategoryGroupFilter";
import MenuSearchInput from "../components/MenuSearchInput";
import MenuFilter from "../components/MenuFilter";
import { MENU_HEADER_HEIGHT } from "../components/MenuListHeader";
import AddMenuToCartModal from "../components/AddMenuToCartModal";
import { MenuItemCardImageTop, MenuItemCardImageBottom, MenuItemCardImageRight } from "../components/menuCard";
import { menuDevelopConfig, menuProductionConfig } from "../components/menuCard/menu-config";

import { ReactComponent as SearchIcon } from "../assets/images/search.svg";
import { ReactComponent as RightArrow } from "../assets/images/right_arrow.svg";
import { ReactComponent as RightLightArrow } from "../assets/images/right_light_arrow.svg";
import { ReactComponent as LeftDarkArrow } from "../assets/images/left_dark_arrow.svg";
import { ReactComponent as LeftArrow } from "../assets/images/left_arrow.svg";
import { ReactComponent as OrderHistoryIcon } from "../modules/assets/images/icons/timecard-icon.svg";
import FilterAltIcon from '@mui/icons-material/FilterAlt';

import styles from "./MenuList2.module.css";

import {
  addMenuItemToCart,
  checkMenuAvailability,
  filterMenuType,
  getRequiredModifierPrice,
  getMenuAvailabilityMessage
} from "../constants/commonFunc";

import RestaurantOpenHoursModal from "../modules/restaurant-closed/RestaurantOpenHoursModal";
import { IconButton } from "@mui/material";

export let THEME_COLOR = "#b99c74";

export let THEME_COLOR2 = "#1d3153";

// Helper function to get menu component based on _idMenuLayout
const getMenuComponent = (_idMenuLayout) => {
  // Determine which config to use based on environment
  const isDevelopment = process.env.NODE_ENV === 'development';
  const menuConfig = isDevelopment ? menuDevelopConfig : menuProductionConfig;

  // If no _idMenuLayout, return MenuItemCardImageRight
  if (!_idMenuLayout) {
    return MenuItemCardImageRight;
  }

  // Find matching component in config
  const configItem = menuConfig.find(item => item.menuId === _idMenuLayout);

  // Return matched component or default to MenuItemCardImageRight
  return configItem ? configItem.component : MenuItemCardImageRight;
};

let FILTER_LIST = [
  {
    _id: 1,
    name: "Chef' Recommends",
  },
  {
    _id: 2,
    name: "New Arrivals",
  },
  {
    _id: 3,
    name: "Appetizers",
  },
  {
    _id: 4,
    name: "Soups & Salads",
  },
  {
    _id: 5,
    name: "Mains",
  },
  {
    _id: 6,
    name: "BAOS",
  },
  {
    _id: 7,
    name: "Wings",
  },
  {
    _id: 8,
    name: "Pizza",
  },
  {
    _id: 9,
    name: "Burgers",
  },
];

let bgColor = { true: THEME_COLOR2, false: THEME_COLOR };
let textColor = { true: "#FFF", false: "#222" };
let textColor2 = { true: THEME_COLOR2, false: "#555" };

let PADDING_HORIZONTAL = 16;
const BOTTOM_HEIGHT = 60;
let TOP_SEARCH_VIEW_HEIGHT = 50;
let CATEGORY_HEIGHT = 50;

let TOP_VIEW_HEIGHT = MENU_HEADER_HEIGHT + TOP_SEARCH_VIEW_HEIGHT;

const filterCat = (cat_list, menu_list) => {
  return JSON.parse(JSON.stringify(cat_list)).filter(
    (x) =>
      !x?.name?.toLowerCase()?.includes("modifier") &&
      x?.enabled &&
      menu_list.filter(
        (y) =>
          y?._idCategory === x?._id &&
          y?.enabled &&
          checkMenuAvailability(y).isItemAvailable
      ).length
  );
};

const filterOutInvisibleCategory = (categoryList) =>
  categoryList.filter(
    (x) => !x.name?.toLowerCase()?.includes("modifier") && x?.enabled
  );

const filterMenuByCat = (menuList, cat, search, menuType) => {
  const categoryId = cat?._id;
  const searchLower = search.toLowerCase();

  return menuList.filter(
    (x) =>
      x._idCategory === categoryId &&
      x?.enabled &&
      // checkMenuAvailability(x?.extras?.availability) &&
      x?.name?.toLowerCase().includes(searchLower) &&
      (x.extras?.menuType === menuType || menuType === "all")
  );
};

const AllCategoryGroup = {
  name: "All",
};

const MenuList2 = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  let { restaurantId, addToCartExist, isRestaurantClosed } = props;
  const groupCategory = props?.restaurantData?.groupCategory || [];
  const storedCategoryGroupData = localStorage.getItem("categoryGroupData");
  const passedCategoryGroupData = storedCategoryGroupData
    ? JSON.parse(storedCategoryGroupData)
    : null;

  const {
    menuListingBgColor = "#FFFFFF",
    menuListingFontColor = null,
    menuListingCategoryBgColor = null,
    menuListingCategoryFontColor = null,
    menuListingSelectedCategoryBgColor = null,
    menuListingSelectedCategoryFontColor = null,
    menuPopupAddToCartBtnBgColor = null,
    menuPopupAddToCartBtnFontColor = null,
    menuListingTopHeaderShadow = true,
    menuListingAddBtnBgColor = null,
    menuListingAddBtnFontColor = null,
    menuListingArBtnBgColor = null,
    menuListingArBtnIconColor = null,
    menuListingBackBtnColor = null,
    menuListingDishNotesBgColor = null,
    menuListingDishNotesFontColor = null,
    menuListingItemImgBgColor = null,
    menuListingMenuTypeFilterBgColor = null,
    menuListingMenuTypeFilterFontColor = null,
    menuListingOrderHistoryIconColor = null,
    menuListingSearchInputBgColor = null,
    menuListingSearchInputIconColor = null,
    menuListingSearchInputFontColor = null,
  } = props?.restaurantData?.themeColors || {};

  const pastOrders = JSON.parse(localStorage.getItem("pastOrders"));
  const showPastOrdersButton = pastOrders || pastOrders?.length > 0;

  const [categoryList, setCategoryList] = useState(
    filterOutInvisibleCategory(
      passedCategoryGroupData
        ? passedCategoryGroupData.categories
        : props.categoryList
    )
  );
  const [menuList, setMenuList] = useState(props.menuList);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [menuType, setMenuType] = useState("all"); // Veg, NonVeg or Both
  const [selectedCategoryGroup, setSelectedCategoryGroup] = useState(
    passedCategoryGroupData ?? AllCategoryGroup
  );
  const [categoryGroupList, setCategoryGroupList] = useState([
    ...groupCategory,
    AllCategoryGroup,
  ]);
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [addMenuToCartModalVisible, setAddMenuToCartModalVisible] =
    useState(false);
  const [menuModelData, setMenuModelData] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [showNoItemText, setShowNoItemText] = useState(false);
  const [menuTypeFilterList, setMenuTypeFilterList] = useState([]);
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedAllergenIds, setSelectedAllergenIds] = useState([]);
  const [appliedAllergenIds, setAppliedAllergenIds] = useState([]);

  const menuScrollRef = useRef(null);
  const autoOpenHandled = useRef(false);
  const menuContainerRef = useRef(null);

  const matchesTag = useCallback((item, tag) => {
    const menuTypeLower = (item.extras?.menuType || "").toLowerCase();
    const nameLower = (item.name || "").toLowerCase();
    const descLower = (item.description || "").toLowerCase();
    const dishnoteLower = (item.dishnote || "").toLowerCase();
    const attrNames = (item.attributes || []).map((attr) => {
      const def = (props.menuAttributesList || []).find(
        (a) => a._id === attr._idAttribute
      );
      return (def?.name || "").toLowerCase();
    });
    const searchFields = [nameLower, descLower, dishnoteLower, menuTypeLower, ...attrNames];

    switch (tag) {
      case "Vegan":
        return menuTypeLower.includes("vegan") || menuTypeLower.includes("plant based");
      case "Vegetarian":
        return menuTypeLower === "vegetarian";
      case "No Raw Fish":
        return !searchFields.some((f) => f.includes("raw fish"));
      case "Spicy":
        return searchFields.some((f) => f.includes("spicy"));
      case "New":
        return attrNames.some((n) => n.includes("new"));
      case "Bestseller":
        return attrNames.some((n) => n.includes("bestseller") || n.includes("best seller"));
      case "High Protein":
        return searchFields.some((f) => f.includes("high protein")) ||
          attrNames.some((n) => n.includes("protein"));
      default: {
        const tagLower = tag.toLowerCase();
        return searchFields.some((f) => f.includes(tagLower));
      }
    }
  }, [props.menuAttributesList]);

  const filteredMenuList = useMemo(() => {
    let result = menuList;

    if (selectedTags.length > 0) {
      result = result.filter((item) =>
        selectedTags.some((tag) => matchesTag(item, tag))
      );
    }

    if (appliedAllergenIds.length > 0) {
      result = result.filter((item) => {
        const itemAllergens = item._idAllergens || [];
        return !itemAllergens.some((id) => appliedAllergenIds.includes(id));
      });
    }

    return result;
  }, [menuList, selectedTags, appliedAllergenIds, matchesTag]);

  const handleTagToggle = useCallback((tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  }, []);

  const handleAllergenToggle = useCallback((allergenId) => {
    setSelectedAllergenIds((prev) =>
      prev.includes(allergenId)
        ? prev.filter((id) => id !== allergenId)
        : [...prev, allergenId]
    );
  }, []);

  const handleApplyAllergenFilter = useCallback(() => {
    setAppliedAllergenIds([...selectedAllergenIds]);
    setShowFilterPanel(false);
  }, [selectedAllergenIds]);

  const handleClearAllFilters = useCallback(() => {
    setSelectedTags([]);
    setSelectedAllergenIds([]);
    setAppliedAllergenIds([]);
  }, []);

  useEffect(() => {
    setSelectedFilter(FILTER_LIST[0]);
  }, []);

  useEffect(() => {
    const autoOpenMenuId = location?.state?.autoOpenMenuId;
    if (autoOpenMenuId && props.menuList.length && !autoOpenHandled.current) {
      const item = props.menuList.find(x => x._id === autoOpenMenuId);
      if (item) {
        autoOpenHandled.current = true;
        setMenuModelData(item);
        setAddMenuToCartModalVisible(true);
      }
    }
  }, [props.menuList]);

  // useEffect(() => {
  //   let category_list = [];
  //   filterCat(props.categoryList, menuList).map((item) => {
  //     let menu_list = filterMenuByCat(menuList, item, searchText, menuType);
  //     if (menu_list.length == 0) {
  //     } else {
  //       category_list.push(item);
  //     }
  //   });
  //   if (category_list.length == 0) {
  //     category_list = filterCat(props.categoryList, menuList);
  //     setShowNoItemText(true);
  //   } else {
  //     setShowNoItemText(false);
  //   }
  //   setCategoryList(category_list);

  //   setSelectedCategory(category_list.length ? category_list[0] : null);
  // }, [searchText, menuType, menuList]);

  useEffect(() => {
    let cart_items = props.cartItems.filter(
      (x) => x._idRestaurant == restaurantId
    );
    setCartItems(cart_items);
  }, [props.cartItems, restaurantId]);


  useEffect(() => {
    if (categoryList.length) {
      let category_id = categoryList[0]._id;
      let list = {};
      categoryList.map(
        (x) =>
        (list = {
          ...list,
          [x._id]: document.getElementById("menuListCategory" + x._id)
            ? {
              current: document.getElementById("menuListCategory" + x._id),
            }
            : React.createRef(),
        })
      );
      menuScrollRef.current = list;
      if (category_id) {
        let el = document.getElementById("mainViewId");
        if (el) {
          el.scrollTo(
            0,
            menuScrollRef.current?.[category_id]?.current?.offsetTop
          );
        }
      }
    }
    onCategoryClick(categoryList[0]);
  }, [categoryList]);

  useEffect(() => {
    const list = props.menuList.filter(
      (x) => typeof x.extras?.menuType !== "undefined"
    );
    const menuTypeList = filterMenuType(list);
    setMenuTypeFilterList(menuTypeList);
    setMenuList(props.menuList);
  }, [props.menuList]);

  const setCategoryGroupType = (value) => {
    if (value === AllCategoryGroup.name) {
      setSelectedCategoryGroup(AllCategoryGroup);
      setCategoryList(filterOutInvisibleCategory(props.categoryList));
    } else {
      const newSelectedCategoryGroup = groupCategory?.find(
        (x) => x.name === value
      );
      setSelectedCategoryGroup(newSelectedCategoryGroup);
      setCategoryList(
        filterOutInvisibleCategory(newSelectedCategoryGroup.categories)
      );
    }
  };

  const onAddMenuItemToCart = (item, note, options, modifiers, count) => {
    const list = addMenuItemToCart(
      restaurantId,
      props.restaurantDetail?._id,
      cartItems,
      count,
      item,
      modifiers,
      options,
      note
    );

    if (restaurantId != props.restaurantDetail?._id) {
      props.updateRestaurantDetail(props?.restaurantData);
    }
    props.updateCartItems(list);

    if (count > 0) {
      setAddMenuToCartModalVisible(false);
      setMenuModelData(null);
    }
  };

  const handleMainScroll = (e) => {
    if (e.target.scrollTop) {
      let filter_cat = null;
      Object.keys(menuScrollRef.current).forEach(function (key, index) {
        let x = menuScrollRef.current[key];
        if (
          x.current?.offsetTop + x.current?.clientHeight >=
          e.target.scrollTop
        ) {
          if (filter_cat == null) {
            filter_cat = x;
          }
        }
      });
      if (filter_cat != null) {
        let cat_id = filter_cat?.current?.attributes["cat-id"]["value"];
        if (selectedCategory?._id != cat_id) {
          categoryList.map((x, i) => {
            if (x._id == cat_id) {
              if (document.getElementById("menuListCategoryName" + cat_id)) {
                document.getElementById(
                  "menuListCategoryName" + cat_id
                ).style.position = "sticky";
              }
              setSelectedCategory(x);
            } else {
              if (document.getElementById("menuListCategoryName" + x._id)) {
                document.getElementById(
                  "menuListCategoryName" + x._id
                ).style.position = "relative";
              }
            }
          });
        }
      }
    }
  };

  const onCategoryClick = (cat) => {
    setSelectedCategory(cat);
    if (menuScrollRef.current) {
      if (menuScrollRef.current?.[cat?._id]?.current) {
        let el = document.getElementById("mainViewId");
        el.scrollTo(
          0,
          menuScrollRef.current?.[cat?._id]?.current?.offsetTop + 15
        );
        if (document.getElementById("menuListCategoryName" + cat?._id)) {
          document.getElementById(
            "menuListCategoryName" + cat?._id
          ).style.position = "sticky";
        }
      } else {
        menuScrollRef.current = {
          ...menuScrollRef.current,
          [cat?._id]: document.getElementById("menuListCategory" + cat?._id)
            ? {
              current: document.getElementById("menuListCategory" + cat?._id),
            }
            : React.createRef(),
        };
      }
    }
  };

  const handleOrderHistoryButtonClick = () => {
    navigate("/restaurant/past-orders", {
      state: {
        from: location?.pathname,
        restaurantId: restaurantId,
        tableNumber: props.tableNumber,
      },
    });
  };

  const onAddClick = (item) => {
    setMenuModelData(item);
    setAddMenuToCartModalVisible(true);
  };

  const onMenuArViewClick = (data) => {
    props.onMenuArViewClick(data);
  };

  const TabScrollBtn = forwardRef((props, ref) => {
    const { direction, disabled, ...other } = props;

    return (
      <ButtonBase component="div" ref={ref} {...other}>
        {direction === "right" ? (
          <Grid sx={{ cursor: "pointer" }}>
            {!disabled ? <RightArrow /> : <RightLightArrow />}
          </Grid>
        ) : (
          <Grid sx={{ cursor: "pointer" }}>
            {!disabled ? <LeftDarkArrow /> : <LeftArrow />}
          </Grid>
        )}
      </ButtonBase>
    );
  });

  return (
    <Grid
      item
      xs={12}
      sx={{ backgroundColor: menuListingBgColor ?? "#FFFFFF", position: "relative" }}
      className={`${styles["main-view"]}`}
      ref={menuContainerRef}
    >
      <Grid
        item
        xs={12}
        sx={{ backgroundColor: menuListingBgColor ?? "#FFFFFF" }}
        className={`${styles["header-view"]}`}
      >
        <Grid
          item
          xs={12}
          sx={{
            height: "52px",
            boxShadow: menuListingTopHeaderShadow
              ? "1px 1px 18px 9px #e6e6e1"
              : "none",
          }}
        >
          {/*<MenuListHeader paddingHorizontal={PADDING_HORIZONTAL} />*/}
          <Grid
            container
            item
            xs={12}
            alignItems={"center"}
            justifyContent={"space-between"}
            px={`${PADDING_HORIZONTAL}px`}
            // sx={{ height: TOP_SEARCH_VIEW_HEIGHT }}
            sx={{
              height: "52px",
              flexWrap: "nowrap",
            }}
          >
            {showSearchInput ? (
              <MenuSearchInput
                value={searchText}
                setValue={setSearchText}
                inputBg={menuListingSearchInputBgColor ?? "#FFF"}
                placeholder={"Search Food Name"}
                border={`1px solid ${THEME_COLOR2}`}
                onClose={() => {
                  setSearchText("");
                  setShowSearchInput(false);
                }}
              />
            ) : (
              <>
                <Box display={"flex"} alignItems="center">
                  <Box
                    ml={-1}
                    sx={{
                      lineHeight: 1,
                      path: { stroke: menuListingBackBtnColor ?? "#000" },
                    }}
                  >
                    <LeftDarkArrow
                      width={24}
                      height={24}
                      style={{ cursor: "pointer" }}
                      onClick={() => props.onBackBtnClick()}
                    />
                  </Box>
                  <Box
                    ml={0.5}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      gap: "0.5rem",
                    }}
                  >
                    {!!menuTypeFilterList?.length && (
                      <MenuTypeFilter
                        value={menuType}
                        list={menuTypeFilterList}
                        height={35}
                        setValue={setMenuType}
                      />
                    )}
                    {categoryGroupList.length > 1 && (
                      <MenuCategoryGroupFilter
                        value={selectedCategoryGroup?.name ?? ""}
                        bgColor={menuListingMenuTypeFilterBgColor ?? "#FFF"}
                        fontColor={menuListingMenuTypeFilterFontColor ?? "#ccc"}
                        list={categoryGroupList.map((x) => x.name)}
                        height={35}
                        setValue={setCategoryGroupType}
                      />
                    )}
                  </Box>
                </Box>
                <Box className={`${styles["right-view"]}`}>
                  {/* {isRestaurantClosed ? (
                    <Typography
                      className={`${styles["rest-closed-text"]} ${styles["font-size"]}`}
                    >
                      RESTAURANT IS CLOSED
                    </Typography>
                  ) : null} */}

                  {showPastOrdersButton && (
                    <IconButton
                      onClick={handleOrderHistoryButtonClick}
                      sx={{
                        color: "#fff",
                        backgroundColor: "transparent !important",
                        borderRadius: "0px",
                        height: "52px",
                        "&:hover": {
                          backgroundColor: "transparent !important",
                        },
                        path: {
                          fill: menuListingOrderHistoryIconColor ?? "#000",
                        },
                      }}
                    >
                      <OrderHistoryIcon height={24} />
                    </IconButton>
                  )}

                  <Box
                    className={styles.searchView}
                    onClick={() => setShowFilterPanel(true)}
                    sx={{
                      backgroundColor:
                        menuListingSearchInputBgColor ?? "#eeeeee",
                      path: { fill: menuListingSearchInputIconColor ?? "#000" },
                      mr: 1
                    }}
                  >
                    <FilterAltIcon width={18} height={18} />
                  </Box>

                  <Box
                    className={styles.searchView}
                    onClick={() => setShowSearchInput(true)}
                    sx={{
                      backgroundColor:
                        menuListingSearchInputBgColor ?? "#eeeeee",
                      path: { fill: menuListingSearchInputIconColor ?? "#000" },
                    }}
                  >
                    <SearchIcon width={18} height={18} />
                  </Box>
                </Box>
              </>
            )}
          </Grid>
        </Grid>

        <Grid
          container
          item
          xs={12}
          className={styles.categoryList}
          // sx={{ height: CATEGORY_HEIGHT }}
          sx={{
            height: "62px",
            mt: 1,
          }}
        >
          <Tabs
            value={selectedCategory?._id}
            variant="scrollable"
            scrollButtons={true}
            allowScrollButtonsMobile={false}
            ScrollButtonComponent={(e) => <TabScrollBtn {...e} />}
            aria-label=""
            orientation="horizontal"
            sx={{
              height: "62px",
              pl: 0.5,
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            {categoryList.map((item, index) => {
              let last_item = categoryList.length == index + 1;

              return (
                <Tab
                  key={index}
                  value={item._id}
                  onClick={() => onCategoryClick(item)}
                  label={item.name}
                  className={styles.categoryListText}
                  sx={{
                    fontFamily: "Inter !important",
                    fontWeight: "600 !important",
                    fontSize: "14px !important",
                    height: "62px",
                    mr: last_item ? 0 : 0.5,
                    // backgroundColor:
                    //   bgColor[item?._id == selectedCategory?._id],
                    // "&.MuiButtonBase-root": {
                    //   color: `${
                    //     textColor[item?._id == selectedCategory?._id]
                    //   } !important`,
                    // },
                    backgroundColor:
                      item?._id === selectedCategory?._id
                        ? menuListingSelectedCategoryBgColor ?? "#02264E"
                        : menuListingCategoryBgColor ?? "#C3A376",
                    "&.MuiButtonBase-root": {
                      color: `${item?._id === selectedCategory?._id
                        ? menuListingSelectedCategoryFontColor ?? "#ffffff"
                        : menuListingCategoryFontColor ?? "#493D35"
                        } !important`,
                    },
                  }}
                />
              );
            })}
          </Tabs>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        className={`${styles["menu-list-main-view"]}`}
        sx={{
          // top: `${TOP_VIEW_HEIGHT + CATEGORY_HEIGHT}px`,
          top: "124px",
        }}
      >
        {/*<Grid*/}
        {/*  container*/}
        {/*  item*/}
        {/*  xs={12}*/}
        {/*  py={2}*/}
        {/*  px={`${PADDING_HORIZONTAL}px`}*/}
        {/*  className={styles.filterList}*/}
        {/*>*/}
        {/*  {FILTER_LIST.map((item, index) => {*/}
        {/*    return (*/}
        {/*      <Box*/}
        {/*        px={2}*/}
        {/*        key={index}*/}
        {/*        className={styles.filterItemList}*/}
        {/*        onClick={() => setSelectedFilter(item)}*/}
        {/*      >*/}
        {/*        <Typography*/}
        {/*          className={styles.filterItemText}*/}
        {/*          sx={{*/}
        {/*            color: textColor2[item?._id == selectedFilter?._id],*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          {item.name}*/}
        {/*        </Typography>*/}
        {/*      </Box>*/}
        {/*    );*/}
        {/*  })}*/}
        {/*</Grid>*/}
        <Grid
          container
          item
          xs={12}
          pb={2}
          className={`${styles["content-view"]}`}
          alignItems={"flex-start"}
          id={"mainViewId"}
          sx={{
            height: `calc(100vh - ${TOP_VIEW_HEIGHT +
              CATEGORY_HEIGHT +
              (cartItems.length && addToCartExist ? BOTTOM_HEIGHT : 0)
              }px)`,
          }}
          onScroll={handleMainScroll}
        >
          {/*<Typography className={styles.menuMainTitle} pb={2}>*/}
          {/*  {selectedFilter?.name}*/}
          {/*</Typography>*/}
          {/*<Grid container item xs={12} pb={2} alignItems={"center"}>*/}
          {/*  <Box className={styles.menuSubTitleView}>*/}
          {/*    <Typography className={styles.menuSubTitle}>INDIAN</Typography>*/}
          {/*  </Box>*/}
          {/*  <UpArrowIcon width={15} height={15} style={{ cursor: "pointer" }} />*/}
          {/*</Grid>*/}
          {showNoItemText ? (
            <Grid
              container
              item
              xs={12}
              justifyContent="center"
              alignItems="center"
              sx={{
                height: `calc(100vh - ${TOP_VIEW_HEIGHT +
                  CATEGORY_HEIGHT +
                  (cartItems.length && addToCartExist ? BOTTOM_HEIGHT : 0) +
                  30
                  }px)`,
              }}
            >
              <Typography py={2} className={styles.noItems}>
                No Items
              </Typography>
            </Grid>
          ) : null}
          {categoryList.map((cat, catIndex) => {
            let last_category = catIndex == categoryList.length - 1;
            let min_height = 0;
            if (last_category) {
              min_height = `calc(100vh - ${TOP_VIEW_HEIGHT +
                CATEGORY_HEIGHT +
                (cartItems.length && addToCartExist ? BOTTOM_HEIGHT : 0) +
                10
                }px)`;
            }
            let menu_list = filterMenuByCat(
              filteredMenuList,
              cat,
              searchText,
              menuType
            );
            if (menu_list.length == 0) {
              return null;
            }
            return (
              <Grid
                key={catIndex}
                item
                xs={12}
                id={"menuListCategory" + cat?._id}
                ref={menuScrollRef.current?.[cat?._id]}
                cat-id={cat?._id}
                sx={last_category ? { minHeight: min_height } : null}
              >
                <Typography
                  pt={2}
                  pb={1}
                  px={`${PADDING_HORIZONTAL}px`}
                  className={styles.menuMainTitle}
                  id={"menuListCategoryName" + cat?._id}
                  sx={{
                    backgroundColor: menuListingBgColor ?? "#FFFFFF",
                    position: catIndex == 0 ? "sticky" : "relative",
                    fontFamily: "Inter !important",
                    fontWeight: "600 !important",
                    fontSize: "24px !important",
                    textTransform: "capitalize !important",
                    color: menuListingFontColor ?? "#000",
                  }}
                >
                  {cat?.name?.toLowerCase()}
                </Typography>
                {menu_list.length == 0 ? (
                  <Typography py={2} className={styles.noItems}>
                    No Items
                  </Typography>
                ) : (
                  menu_list.map((item, index) => {
                    // Get the appropriate menu component based on _idMenuLayout
                    const MenuComponent = getMenuComponent(props.restaurantData?._idMenuLayout);

                    const hideMenuThumbNail = item?.extras?.hideMenuThumbNailImages;
                    const isModelExist = item.modelId != null && item.modelId != "";
                    const itemPrice = (
                      item?.price?.value
                        ? item.price.value
                        : getRequiredModifierPrice(
                          item?.modifiers,
                          props.menuList
                        )
                    );
                    const dishNotes =
                      item?.dishnote?.toLowerCase() == "nil" ||
                        item?.dishnote?.toUpperCase() == "NA" ||
                        item?.dishnote == "0"
                        ? []
                        : item?.dishnote?.split(",") ?? [];
                    let item_image = "";
                    if (item.images?.length) {
                      item_image = item.images?.[0];
                    }

                    const cartCount =
                      cartItems
                        .filter(
                          (x) =>
                            x._idCategory === item._idCategory &&
                            x._id === item._id
                        )
                        ?.reduce((sum, cur) => sum + cur.count, 0) ?? 0;

                    const { isItemAvailable, availabilityMessage } = checkMenuAvailability(item);

                    // Common props for all menu components
                    const commonProps = {
                      key: index,
                      image: item_image,
                      name: item.name,
                      description: item.description,
                      price: itemPrice,
                      currency: item.price.currency,
                      onClick: isItemAvailable ? () => onAddClick(item) : undefined,
                      bgColor: menuListingBgColor,
                      fontColor: menuListingFontColor,
                      imageBgColor: menuListingItemImgBgColor,
                      restaurantLogo: props.restaurantData?.logo,
                      hasARModel: isModelExist,
                      onArViewClick: isItemAvailable ? () => onMenuArViewClick(item) : undefined,
                      arBtnBgColor: menuListingArBtnBgColor,
                      arBtnIconColor: menuListingArBtnIconColor,
                      addToCartExist: addToCartExist && isItemAvailable,
                      cartCount: cartCount,
                      addBtnBgColor: menuListingAddBtnBgColor,
                      addBtnFontColor: menuListingAddBtnFontColor,
                      isItemAvailable: isItemAvailable,
                      availabilityMessage: getMenuAvailabilityMessage(item?.extras?.availability),
                      allergenIds: item._idAllergens,
                      attributes: item.attributes,
                      menuContainerRef,
                      menuItemId: item._id,
                    };

                    // Props specific to MenuItemCardImageRight
                    const menuDefaultProps = {
                      ...commonProps,
                      menuType: item?.extras?.menuType,
                      dishNotes: dishNotes,
                      hideMenuThumbNail: hideMenuThumbNail,
                      dishNotesBgColor: menuListingDishNotesBgColor,
                      dishNotesFontColor: menuListingDishNotesFontColor,
                      paddingHorizontal: PADDING_HORIZONTAL,
                      allergies: item?.allergies,
                      calories: item?.calories,
                      nutritions: item?.nutritions,
                    };

                    // Render MenuItemCardImageTop/MenuItemCardImageBottom with Box wrapper or MenuItemCardImageRight directly
                    if (MenuComponent === MenuItemCardImageTop || MenuComponent === MenuItemCardImageBottom) {
                      return (
                        <Box key={index} px={`${PADDING_HORIZONTAL}px`} pb={2}>
                          <MenuComponent {...commonProps} />
                        </Box>
                      );
                    } else {
                      return <MenuComponent {...menuDefaultProps} />;
                    }
                  })
                )}
              </Grid>
            );
          })}
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        className={styles.bottomView}
        sx={{
          height: cartItems.length && addToCartExist ? BOTTOM_HEIGHT : 0,
        }}
      >
        {/*<Typography className={styles.text1} mb={0.3}>*/}
        {/*  Government taxes as applicable, we levy a 7.5% service change*/}
        {/*</Typography>*/}
        {cartItems.length && addToCartExist ? (
          <Box
            className={`${styles.viewCart} device-width`}
            sx={{
              backgroundColor: menuPopupAddToCartBtnBgColor ?? "#000000",
              height: BOTTOM_HEIGHT,
              display: "flex",
              flexDirection: "row",
              gap: "8px",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={props.onCartClick}
          >
            <Typography
              className={styles.viewCartText}
              sx={{ color: menuPopupAddToCartBtnFontColor ?? "#FFFFFF" }}
            >
              View Cart
            </Typography>
            <Typography
              className={styles.viewCartCount}
              sx={{
                color: menuPopupAddToCartBtnFontColor ?? "#FFFFFF",
                mt: 0.3,
              }}
            >
              .&nbsp; &nbsp;{cartItems.length} Items
            </Typography>
          </Box>
        ) : null}
      </Grid>
      <AddMenuToCartModal
        page={"MenuList"}
        locale={"en"}
        visible={addMenuToCartModalVisible}
        data={menuModelData}
        addToCartExist={addToCartExist}
        menuList={props.menuList}
        onClose={() => {
          setAddMenuToCartModalVisible(false);
          setTimeout(() => {
            setMenuModelData(null);
          }, 200);
        }}
        onAddMenuItemToCart={onAddMenuItemToCart}
        // onAllergensClick={() => null}
        menuContainerRef={menuContainerRef}
      />
      <RestaurantOpenHoursModal open={isRestaurantClosed} />
      <MenuFilter
        open={showFilterPanel}
        onClose={() => setShowFilterPanel(false)}
        selectedTags={selectedTags}
        onTagToggle={handleTagToggle}
        selectedAllergenIds={selectedAllergenIds}
        onAllergenToggle={handleAllergenToggle}
        onApplyAllergenFilter={handleApplyAllergenFilter}
        allergenList={props.allergenList || []}
        onClearAll={handleClearAllFilters}
        themeColors={props.restaurantData?.themeColors || {}}
      />
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    cartItems: state.restaurantData.cartItems,
    restaurantDetail: state.restaurantData.restaurantDetail,
    locale: state.restaurantData.locale,
    allergenList: state.apiData.allergenList,
    menuAttributesList: state.apiData.menuAttributesList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCartItems: (data) => dispatch(updateCartItems(data)),
    updateRestaurantDetail: (data) => dispatch(updateRestaurantDetail(data)),
    updateSelectedMenuData: (data) => dispatch(updateSelectedMenuData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuList2);


